// Version : 0.0.2
// Author : VISHAL BHARATHI
// LastEdit : VISHAL BHARATHI
// Last ADD : DESTRUCTURING
// MODFIED DATA : 26-09-2025

import { call, takeLatest, put, all } from 'redux-saga/effects';

import {
	SubGroupAccountDetailsAdd,
	SubGroupAccountDetailsDelete,
	SubGroupAccountDetailsFetch,
	SubGroupAccountDetailsUpdate,
	SubGroupAccountListGet,
} from './subGroupAccount.services';
import {
	// ADD SUB GROUP ACCOUNT DETAILS
	addSubGroupAccountDetailsFailure,
	addSubGroupAccountDetailsResponseChanged,
	addSubGroupAccountDetailsSuccess,
	// DELETE SUB GROUP ACCOUNT DETAILS
	deleteSubGroupAccountDetailsFailure,
	deleteSubGroupAccountDetailsResponseChanged,
	deleteSubGroupAccountDetailsSuccess,
	// FETCH SUB GROUP ACCOUNT DETAILS
	fetchSubGroupAccountDetailsFailure,
	fetchSubGroupAccountDetailsResponseChanged,
	fetchSubGroupAccountDetailsSuccess,
	// GET SUB GROUP ACCOUNT LIST
	getSubGroupAccountListFailure,
	getSubGroupAccountListResponseChanged,
	getSubGroupAccountListSuccess,
	// UPDATE SUB GROUP ACCOUNT DETAILS
	updateSubGroupAccountDetailsFailure,
	updateSubGroupAccountDetailsResponseChanged,
	updateSubGroupAccountDetailsSuccess,
} from './subGroupAccount.action';
import SubGroupAccountActionTypes from './subGroupAccount.types';
import { encryptData } from '../../../_common/enode-decode';

import AlertManager from '../../../../utils/alertManager';
/** ***************** ADD SUB GROUP ACCOUNT DETAILS START *********************** */
export function* addSubGroupAccountDetails({ payload }: any) {
	try {
		const key = 'CreateSubGroupAccountKey';
		const {
			infogCompanyID,
			userID,
			userName,
			groupAccountID,
			subGroupAccountName,
			isMultiple,
			databaseName,
			sendSubSugGroupAccountArr,
		} = payload;
		const jsonData = {
			InfogID: infogCompanyID,
			UserID: userID,
			UserName: userName,
			GroupAccountID: groupAccountID,
			SubGroupAccountName: subGroupAccountName,
			IsMultiple: isMultiple,
			DatabaseName: databaseName,
			SubSubGroupAccountArr: sendSubSugGroupAccountArr,
		};

		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(SubGroupAccountDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addSubGroupAccountDetailsFailure(responseData.data));
		} else {
			yield put(addSubGroupAccountDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addSubGroupAccountDetailsFailure(error));
	}
}

export function* resetAddSubGroupAccountDetailsResponse() {
	yield put(addSubGroupAccountDetailsResponseChanged());
}

export function* onAddSubGroupAccountDetails() {
	yield takeLatest(
		SubGroupAccountActionTypes.ADD_SUB_GROUP_ACCOUNT_DETAILS_START,
		addSubGroupAccountDetails,
	);
}

export function* onAddSubGroupAccountDetailsResponseReset() {
	yield takeLatest(
		SubGroupAccountActionTypes.ADD_SUB_GROUP_ACCOUNT_DETAILS_RESPONSE_RESET,
		resetAddSubGroupAccountDetailsResponse,
	);
}
/** ***************** ADD SUB GROUP ACCOUNT DETAILS END *********************** */

/** ***************** UPDATE SUB GROUP ACCOUNT DETAILS START *********************** */
export function* updateSubGroupAccountDetails({ payload }: any) {
	try {
		const key = 'UpdateSubGroupAccountKey';
		const {
			infogCompanyID,
			userID,
			userName,
			groupAccountID,
			subGroupAccountID,
			subGroupAccountName,
			isMultiple,
			databaseName,
			sendSubSugGroupAccountArr,
		} = payload;
		const jsonData = {
			InfogID: infogCompanyID,
			UserID: userID,
			UserName: userName,
			GroupAccountID: groupAccountID,
			SubGroupAccountID: subGroupAccountID,
			SubGroupAccountName: subGroupAccountName,
			IsMultiple: isMultiple,
			DatabaseName: databaseName,
			SubSubGroupAccountArr: sendSubSugGroupAccountArr,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(SubGroupAccountDetailsUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateSubGroupAccountDetailsFailure(responseData.data));
		} else {
			yield put(updateSubGroupAccountDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateSubGroupAccountDetailsFailure(error));
	}
}

export function* resetUpdateSubGroupAccountDetailsResponse() {
	yield put(updateSubGroupAccountDetailsResponseChanged());
}

export function* onUpdateSubGroupAccountDetails() {
	yield takeLatest(
		SubGroupAccountActionTypes.UPDATE_SUB_GROUP_ACCOUNT_DETAILS_START,
		updateSubGroupAccountDetails,
	);
}

export function* onUpdateSubGroupAccountDetailsResponseReset() {
	yield takeLatest(
		SubGroupAccountActionTypes.UPDATE_SUB_GROUP_ACCOUNT_DETAILS_RESPONSE_RESET,
		resetUpdateSubGroupAccountDetailsResponse,
	);
}
/** ***************** UPDATE SUB GROUP ACCOUNT DETAILS END *********************** */

/** ***************** GET SUB GROUP ACCOUNT LIST START *********************** */
export function* getSubGroupAccountList({ payload }: any) {
	try {
		const key = 'FetchAllSubGroupAccountKey';
		const { infogCompanyID, inputSearch, databaseName, limit } = payload;
		const jsonData = {
			InfogID: infogCompanyID,
			InputSearch: inputSearch,
			DatabaseName: databaseName,
			Limit: limit,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(SubGroupAccountListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getSubGroupAccountListFailure(responseData.data));
		} else {
			yield put(getSubGroupAccountListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getSubGroupAccountListFailure(error));
	}
}

export function* resetGetSubGroupAccountListResponse() {
	yield put(getSubGroupAccountListResponseChanged());
}

export function* onGetSubGroupAccountList() {
	yield takeLatest(
		SubGroupAccountActionTypes.GET_SUB_GROUP_ACCOUNT_LIST_START,
		getSubGroupAccountList,
	);
}

export function* onGetSubGroupAccountListResponseReset() {
	yield takeLatest(
		SubGroupAccountActionTypes.GET_SUB_GROUP_ACCOUNT_LIST_RESPONSE_RESET,
		resetGetSubGroupAccountListResponse,
	);
}
/** ***************** GET SUB GROUP ACCOUNT LIST END *********************** */

/** ***************** FETCH SUB GROUP ACCOUNT DETAILS START *********************** */
export function* fetchSubGroupAccountDetails({ payload }: any) {
	try {
		const key = 'FetchSubGroupAccountKey';
		const { infogCompanyID, subGroupAccountID, databaseName } = payload;
		const jsonData = {
			InfogID: infogCompanyID,
			SubGroupAccountID: subGroupAccountID,
			DatabaseName: databaseName,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(SubGroupAccountDetailsFetch, encodeData);

		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchSubGroupAccountDetailsFailure(responseData.data));
		} else {
			yield put(fetchSubGroupAccountDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchSubGroupAccountDetailsFailure(error));
	}
}

export function* resetFetchSubGroupAccountDetailsResponse() {
	yield put(fetchSubGroupAccountDetailsResponseChanged());
}

export function* onFetchSubGroupAccountDetails() {
	yield takeLatest(
		SubGroupAccountActionTypes.FETCH_SUB_GROUP_ACCOUNT_DETAILS_START,
		fetchSubGroupAccountDetails,
	);
}

export function* onFetchSubGroupAccountDetailsResponseReset() {
	yield takeLatest(
		SubGroupAccountActionTypes.FETCH_SUB_GROUP_ACCOUNT_DETAILS_RESPONSE_RESET,
		resetFetchSubGroupAccountDetailsResponse,
	);
}
/** ***************** FETCH SUB GROUP ACCOUNT DETAILS END *********************** */

/** ***************** DELETE SUB GROUP ACCOUNT DETAILS START *********************** */
export function* deteleSubGroupAccountDetails({ payload }: any) {
	try {
		const key = 'DeleteSubGroupAccountKey';
		const { infogCompanyID, subGroupAccountID, databaseName, userName, userID } = payload;
		const jsonData = {
			InfogID: infogCompanyID,
			SubGroupAccountID: subGroupAccountID,
			UserName: userName,
			UserID: userID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(SubGroupAccountDetailsDelete, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteSubGroupAccountDetailsFailure(responseData.data));
		} else {
			yield put(deleteSubGroupAccountDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteSubGroupAccountDetailsFailure(error));
	}
}

export function* resetDeleteSubGroupAccountDetailsResponse() {
	yield put(deleteSubGroupAccountDetailsResponseChanged());
}

export function* onDeleteSubGroupAccountDetails() {
	yield takeLatest(
		SubGroupAccountActionTypes.DELETE_SUB_GROUP_ACCOUNT_DETAILS_START,
		deteleSubGroupAccountDetails,
	);
}

export function* onDeleteSubGroupAccountDetailsResponseReset() {
	yield takeLatest(
		SubGroupAccountActionTypes.DELETE_SUB_GROUP_ACCOUNT_DETAILS_RESPONSE_RESET,
		resetDeleteSubGroupAccountDetailsResponse,
	);
}
/** ***************** DELETE SUB GROUP ACCOUNT DETAILS END *********************** */

export function* subGroupAccountSaga() {
	yield all([
		// ADD SUB GROUP ACCOUNT DETAILS
		call(onAddSubGroupAccountDetails),
		call(onAddSubGroupAccountDetailsResponseReset),
		// UPDATE SUB GROUP ACCOUNT DETAILS
		call(onUpdateSubGroupAccountDetails),
		call(onUpdateSubGroupAccountDetailsResponseReset),
		// GET SUB GROUP ACCOUNT LIST
		call(onGetSubGroupAccountList),
		call(onGetSubGroupAccountListResponseReset),
		// FETCH SUB GROUP ACCOUNT DETAILS
		call(onFetchSubGroupAccountDetails),
		call(onFetchSubGroupAccountDetailsResponseReset),
		// DELETE SUB GROUP ACCOUNT DETAILS
		call(onDeleteSubGroupAccountDetails),
		call(onDeleteSubGroupAccountDetailsResponseReset),
	]);
}
